import webSite from "@/api/webSite";
import orderApi from "@/api/orderApi";
import config from "../../config";
import utils from "../../utils";
import Vue from "vue";

const base = {
  namespaced: true,
  state: {
    orderNum: 0,
    topUpShow: false,
    loginShow: false,
    utilsStatus: {
      isOpen: true,
      utilsLeft: "left:0px",
      utilsWidth: "utils-open",
    },
    qqGrouptList: [], // q群信息
    articlesList: [], // 全部文章
    gameplayList: [], // 游戏特色
    strategyList: [], // 游戏攻略
    gameDataList: [], // 江湖资料
    contactiList: [], // 联系方式
    wallpaperList: [], // 精美壁纸
    screenshotList: [], // 游戏截图
  },
  mutations: {
    getAllNews(state, payload) {
      const list = JSON.parse(JSON.stringify(payload));
      let gameplayList = list.filter((e) => e.newsType == 4);
      state.articlesList = list;
      state.gameplayList = gameplayList;
    },


    getContactInfo(state, payload) {
      state.contactiList = payload;
    },

    searchNewsById(state, payload) {
      state.article = payload;
    },

    searchStrategy(state, payload) {
      state.strategyList = payload;
    },

    searchGameData(state, payload) {
      // console.log(state)
      let media = ["精美壁纸", "游戏截图", "精彩视频", "Q群信息"];
      let qqGrouptList = payload.filter((e) => e.strategyType == "Q群信息");

      let { imgStr, title } = qqGrouptList[0].strategyEntity[0];
      Vue.set(config.outsidelinkList[1], "codesrc", imgStr);
      Vue.set(config.outsidelinkList[1], "account", "群号：" + title);
    },

    loginDialog(state, payload) {
      state.loginShow = payload;
    },

    topUpDialog(state, payload) {
      state.topUpShow = payload;
    },

    setUtilsLeft(state, payload) {
      state.utilsStatus.utilsLeft = payload;
    },
    setUtilsWidth(state, payload) {
      state.utilsStatus.utilsWidth = payload;
    },
    getOrderNum(state, payload) {
      state.orderNum = payload;
    },
  },
  actions: {
    // 获取全部文章
    async getAllNews({ commit }) {
      const res = await webSite.getAllNews();
      commit("getAllNews", res.data);
    },

    // 获取版本介绍
    async searchOthers({ commit }, params) {
      const res = await webSite.searchOthers(params);
      return res.data;
    },

    // 获取页脚信息
    async searchFooter({ commit }, params) {
      const res = await webSite.searchFooter(params);
      return res.data;
    },

    // ID获取文章
    async searchNewsById({ commit }, params) {
      const res = await webSite.searchNewsById(params);
      return res.data;
    },

    // 获取下载地址
    async getDownloadUrl({ commit }) {
      let {
        data: { anxUrl, iosUrl,pcUrl },
      } = await webSite.getDownloadUrl();
      return { anxUrl, iosUrl,pcUrl };
    },

    // 获取攻略
    async searchStrategy({ commit }) {
      const res = await webSite.searchStrategy();
      commit("searchStrategy", res.data);
    },

    // 获取游戏资料
    async searchGameData({ commit }) {
      const res = await webSite.searchGameData();
      commit("searchGameData", res.data);
    },

    // 获取活动图片
    async getActivityImg({ commit }, query) {
      const res = await webSite.getActivityImg();
      commit("getActivityImg", res.data);
    },

    // 获取联系方式
    async getContactInfo({ commit }, query) {
      const res = await webSite.getContactInfo();
      commit("getContactInfo", res.data);
    },

    // 获取预约人数
    async getOrderNum({ commit }, query) {
      const res0 = await webSite.getOrderNum();
      const res1 = await orderApi.getRealOrderNum();
      const orderNum = Number(res1.data.count) + Number(res0.data);
      commit("getOrderNum", orderNum);
    },
  },
  getters: {
    utilsStatus(state) {
      return state.utilsStatus;
    },
    topUpShow(state) {
      return state.topUpShow;
    },
    loginShow(state) {
      return state.loginShow;
    },
    articlesList(state) {
      return state.articlesList;
    },
    gameplayList(state) {
      return state.gameplayList;
    },
    strategyList(state) {
      return state.strategyList;
    },
    gameDataList(state) {
      return state.gameDataList;
    },
    contactiList(state) {
      return state.contactiList;
    },

    wallpaperList(state) {
      return state.wallpaperList;
    },
    screenshotList(state) {
      return state.screenshotList;
    },
    qqGrouptList(state) {
      return state.qqGrouptList;
    },
  },
};

export default base;
